import React from "react";
import { Link, useNavigate } from "react-router-dom";
import LangSwithcher from "../../components/helpers/LangSwithcher";
import { useTranslation } from "react-i18next";


const AccountFailure = () => {
     const {t,i18n} = useTranslation();
    
        return (
            <>
            <div className="absolute w-[calc(100%-48px)] top-[24px] start-[24px] flex flex-nowrap">
                <div className="w-[50%] h-[47px]">
                  <Link to="/"><img src="/assets/images/logo-normal.svg" className="w-[128px] h-[47px]" alt="" /></Link>
                </div>
                <div className="w-[50%] h-[47px] text-end">
                  {/* <LangSwithcher style="auth" /> */}
                </div>
              </div>
              <div className="pt-[25vh] pb-[50px] text-center h-full min-h-[100vh]">
                <div className="rounded-[16px] bg-white mx-auto my-[15px] w-[calc(100%-30px)] max-w-[911px] p-[5px] text-center">
                    <img src="/assets/images/error.svg" alt="" className="inline-block mt-[30px] mb-[20px] w-[130px] h-auto"  />
                    <h3 className="text-grey-900 text-[40px] font-[600] leading-[74px] mb-0">حدث خطأ</h3>
                    <p className="text-grey-900 text-[28px] font-[500] leading-[51px] mb-[15px]">فشلت عملية الدفع</p>
                    <p className="text-grey-900 text-[24px] font-[500] leading-[36px] mb-[25px]">نرجو التواصل مع الدعم</p>
                </div>
              </div>
            </>
        )
}

export default AccountFailure;
